import { takeEvery, put, fork } from "redux-saga/effects"
import { getFirebase } from "react-redux-firebase"
import { navigate } from "gatsby"
import axios from "axios"
import Cookies from "universal-cookie"

import {
  LOGIN_WITH_TOKEN_REQUEST,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  AUTHENTICATED,
} from "./redux"

export function* syncProfile({ type }) {
  try {
    yield put({
      type: LOGIN_SUCCESS,
    })

    if (type === "password") {
      navigate("/app/design")
    }
  } catch (error) {
    window.Sentry.captureException(error)
  }
}

export function* loginAsync({ payload }) {
  try {
    const { email, password } = payload
    const firebase = getFirebase()

    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

    const auth = yield firebase.login({ email, password })
    const { user } = auth

    if (user) {
      const { uid } = user.user

      yield fork(syncProfile, { uid, type: "password" })
    }
  } catch (error) {
    yield put({ type: LOGIN_FAILURE, payload: error })

    window.Sentry.captureException(error)
  }
}

export function* loginTokenAsync({ payload }) {
  try {
    const { uid } = payload
    const firebase = getFirebase()

    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

    const auth = yield firebase.login({ token: uid })

    if (auth) {
      yield fork(syncProfile, { uid: auth.user.user.uid, type: "token" })
    }
  } catch (error) {
    if (error.code === "auth/invalid-custom-token") {
      window.Sentry.captureMessage("invalid-custom-token but will work")
      window.location.search = ""
      return
    }
    window.Sentry.captureException(error)
  }
}

export function* tokenAsync({ payload }) {
  try {
    const { shop } = payload
    const cookies = new Cookies()
    const firebase = getFirebase()

    if (!shop) {
      return false
    }

    const queryParams = window.location.search || cookies.get("hmac_query")
    const urlParams = new URLSearchParams(queryParams)
    const uid = urlParams.get("uid")

    if (uid) {
      const auth = yield firebase.login({ token: uid })

      if (auth) {
        yield fork(syncProfile, auth.user.user.uid)
      }
    } else {
      const response = yield axios.post(`/api/auth`, { shop })

      if (response) {
        if (response.data && response.data.body) {
          const redirectUrl = response.data.body

          if (window.top === window.self) {
            window.top.location.href = redirectUrl
          } else {
            let normalizedLink = document.createElement("a")
            normalizedLink.href = redirectUrl

            const message = JSON.stringify({
              message: "Shopify.API.remoteRedirect",
              data: { location: normalizedLink.href },
            })
            window.parent.postMessage(message, `https://${shop}`)
          }
        }
      }
    }
  } catch (error) {
    window.Sentry.captureException(error)
  }
}

export function* watchAuth() {
  yield takeEvery(LOGIN_WITH_TOKEN_REQUEST, loginTokenAsync)
  yield takeEvery(AUTHENTICATED, tokenAsync)
  yield takeEvery(LOGIN_REQUEST, loginAsync)
}

export default watchAuth
